export default "__VITE_ASSET__CRE18fXT__"